import React from "react";

import {
    getTipoArquivoImagem
} from '../../services/utils';

// Imagens Ultra Pequenas
import pdfPng from '../../assets/iconsFiles/ImagensUltraPequenas/PDF.png';
import excelPng from '../../assets/icons/iconExcelNovo.svg';
import mp4Png from '../../assets/iconsFiles/ImagensUltraPequenas/mp4.png';
import pastaPng from '../../assets/iconsFiles/ImagensUltraPequenas/Pasta.png';
import powerPointPng from '../../assets/iconsFiles/ImagensUltraPequenas/PowerPoint.png';
import psdPng from '../../assets/iconsFiles/ImagensUltraPequenas/PSD.png';
import txtPng from '../../assets/iconsFiles/ImagensUltraPequenas/TXT.png';
import wordPng from '../../assets/iconsFiles/ImagensUltraPequenas/Word.png';

// Imagens Pequenas
import pdfPngP from '../../assets/iconsFiles/ImagensPequenas/PDF.png';
import excelPngP from '../../assets/iconsFiles/ImagensPequenas/Excel.png';
import mp4PngP from '../../assets/iconsFiles/ImagensPequenas/mp4.png';
import pastaPngP from '../../assets/iconsFiles/ImagensPequenas/Pasta.png';
import powerPointPngP from '../../assets/iconsFiles/ImagensPequenas/PowerPoint.png';
import psdPngP from '../../assets/iconsFiles/ImagensPequenas/PSD.png';
import txtPngP from '../../assets/iconsFiles/ImagensPequenas/TXT.png';
import wordPngP from '../../assets/iconsFiles/ImagensPequenas/Word.png';

// Imagens Medias
import pdfPngM from '../../assets/iconsFiles/ImagensMedia/PDF.png';
import excelPngM from '../../assets/icons/iconExcelNovo.svg';
import mp4PngM from '../../assets/iconsFiles/ImagensMedia/mp4.png';
import pastaPngM from '../../assets/iconsFiles/ImagensMedia/Pasta.png';
import powerPointPngM from '../../assets/iconsFiles/ImagensMedia/PowerPoint.png';
import psdPngM from '../../assets/iconsFiles/ImagensMedia/PSD.png';
import txtPngM from '../../assets/iconsFiles/ImagensMedia/TXT.png';
import wordPngM from '../../assets/iconsFiles/ImagensMedia/Word.png';

// Imagens Grandes
import pdfPngG from '../../assets/iconsFiles/ImagensGrandes/PDF.png';
import excelPngG from '../../assets/icons/iconExcelNovo.svg';
import mp4PngG from '../../assets/iconsFiles/ImagensGrandes/MP4.png';
import pastaPngG from '../../assets/iconsFiles/ImagensGrandes/Pasta.png';
import powerPointPngG from '../../assets/iconsFiles/ImagensGrandes/PowerPoint.png';
import psdPngG from '../../assets/iconsFiles/ImagensGrandes/PSD.png';
import txtPngG from '../../assets/iconsFiles/ImagensGrandes/TXT.png';
import wordPngG from '../../assets/iconsFiles/ImagensGrandes/Word.png';

// Default
import infoArquivoSvg from '../../assets/icons/infoArquivo.svg';

const IconeArquivos = ({
    tipo,
    tamanho,
    style
}) => {

    const [icone, setIcone] = React.useState(infoArquivoSvg);

    React.useEffect(() => {
        renderIcon();
    }, [tipo])

    const renderIcon = () => {
        let tipoIcone = getTipoArquivoImagem(tipo);
        switch (tamanho) {
            case 'G':
                if (tipoIcone == 'PDF') {
                    setIcone(pdfPngG);
                } else if (tipoIcone == 'Excel'){
                    setIcone(excelPngG);
                } else if (tipoIcone == 'MP4') {
                    setIcone(mp4PngG);
                } else if (tipoIcone == 'PowerPoint') {
                    setIcone(powerPointPngG);
                } else if (tipoIcone == 'PSD') {
                    setIcone(psdPngG);
                } else if (tipoIcone == 'TXT') {
                    setIcone(txtPngG);
                } else if (tipoIcone == 'Word') {
                    setIcone(wordPngG);
                }
            case 'M':
                if (tipoIcone == 'PDF') {
                    setIcone(pdfPngM);
                } else if (tipoIcone == 'Excel'){
                    setIcone(excelPngM);
                } else if (tipoIcone == 'MP4') {
                    setIcone(mp4PngM);
                } else if (tipoIcone == 'PowerPoint') {
                    setIcone(powerPointPngM);
                } else if (tipoIcone == 'PSD') {
                    setIcone(psdPngM);
                } else if (tipoIcone == 'TXT') {
                    setIcone(txtPngM);
                } else if (tipoIcone == 'Word') {
                    setIcone(wordPngM);
                }
            case 'P':
                 if (tipoIcone == 'PDF') {
                     setIcone(pdfPng);
                 } else if (tipoIcone == 'Excel'){
                     setIcone(excelPng);
                 } else if (tipoIcone == 'MP4') {
                     setIcone(mp4Png);
                 } else if (tipoIcone == 'PowerPoint') {
                     setIcone(powerPointPng);
                 } else if (tipoIcone == 'PSD') {
                     setIcone(psdPng);
                 } else if (tipoIcone == 'TXT') {
                     setIcone(txtPng);
                 } else if (tipoIcone == 'Word') {
                     setIcone(wordPng);
                 }
            default:
                break;

        }
    }


    return (
        <img style={style}  src={icone} alt={tipo} />
    )
}

export default  IconeArquivos;